import { getEnumValues } from '@myre/common-primitives';

import { DropdownSearchType } from '../types/search.type';

export function searchTypeAttribute(
  value: unknown | undefined,
): DropdownSearchType {
  if (getEnumValues(DropdownSearchType).includes(value as DropdownSearchType)) {
    return value as DropdownSearchType;
  }

  return DropdownSearchType.Soft;
}
